<template>
  <div class="tab-wallet">
    <div class="coming-soon">
      <div class="coming-soon-icon">👷‍♂️🛠️</div>
      <div class="coming-soon-text">Work In Progress</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { analyticsService } from '@/services/analytics.service'
analyticsService.logTab('Wallet')
</script>

<style lang="scss">
.tab-wallet {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--black-color);
  padding: 20px;
  .coming-soon {
    padding: 20px;
    text-align: center;
    width: 100%;
    .coming-soon-icon {
      font-size: 50px;
    }
    .coming-soon-text {
      font-family: 'Forma DJR Display';
      letter-spacing: 0.64px;
    }
  }
}
</style>
